import { useState } from 'react'
import { Button } from 'baseui/button';
import AddBacnetMappingModal from './AddBacnetMappingModal';
import { BacnetObjectState } from '../../../services/mapping/bacnet';
import { AccessRoles, useHasRole } from '../../../hooks/useHasRole';
import { VscAdd } from 'react-icons/vsc';


const CreateConfigurationDialog = (props: { bacnetObject: BacnetObjectState, bacnetDeviceId: number, resourceGroupId: string }) => {
    const [isOpen, setIsOpen] = useState(false);
    const hasAccessMappingWrite = useHasRole(AccessRoles.Mapping.Write);

    const handleSetIsOpen = (value: boolean) => setIsOpen(value)

    return (
        <>
            <Button disabled={!hasAccessMappingWrite} onClick={() => handleSetIsOpen(true)} shape='round' kind='secondary'>
                <VscAdd />
            </Button>
            {isOpen && <AddBacnetMappingModal {...props} isOpen={isOpen} setIsOpen={handleSetIsOpen}></AddBacnetMappingModal>}
        </>
    );
}
export default CreateConfigurationDialog;

